<template>
    <div class="ownerInfo">
        <div class="header">
            <p class="herder_title">欢迎您成为台铃车主！</p>
        </div>
        <div class="card">
            <p class="tips">完善您的资料，获得车主码</p>
            <van-form>
                <!-- <van-cell-group inset> -->
                <van-field v-model="user.phone" center readonly label-width="70" label-class="lablestyle"
                    placeholder="请输入手机号">
                    <template slot="label">
                        <div class="lablestyle">
                            <span style="color:red">*</span><span class="lable_t">手&nbsp; 机 &nbsp;号</span>
                        </div>
                    </template>
                    <template #button>
                        <van-button size="small" type="primary" class="phone" @click="changePhone">切换账号</van-button>
                    </template>
                </van-field>
                <van-field v-model="user.name" clearable name="用户名" maxlength="20" label-width="70"
                    placeholder="请输入姓名">
                    <template slot="label">
                        <div class="lablestyle">
                            <span style="color:red">*</span><span class="lable_t">姓  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;   名</span> </div>
                    </template>
                </van-field>

                <van-field name="radio" label="性   别" label-width="70">
                    <template slot="label">
                        <div class="lablestyle">
                            <span style="color:red">*</span> <span class="lable_t">性 &nbsp;&nbsp;&nbsp;&nbsp;   别</span> </div>
                    </template>
                    <template #input>
                        <van-radio-group v-model="user.sex" direction="horizontal">
                            <van-radio name="0" icon-size="18" checked-color="#FF323A">女士
                                <template #icon="props">
                                    <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                                </template>
                            </van-radio>
                            <van-radio name="1" icon-size="18" checked-color="#FF323A">男士
                                <template #icon="props">
                                    <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                                </template>
                            </van-radio>
                        </van-radio-group>
                    </template>
                </van-field>
                <!-- <van-field name="uploader" label="身份证正面">
                    <template slot="label">
                        <div>身份证正面</div>
                    </template>
                    <template #input>
                        <van-uploader  v-model="fileList" :before-read="beforeRead"  :after-read="afterRead" :max-count="1" />
                    </template>
                </van-field> -->
                <van-field v-model="user.code" label-width="70" placeholder="可手动输入或拍照识别" class="endfield">
                    <template slot="label">
                        <div class="lablestyle ">
                            <span class="lable_t">身份证号</span></div>
                    </template>
                    <template #button>
                        <van-uploader :before-read="beforeRead" :after-read="afterRead" :max-count="1">
                            <img src="../../assets/owner/camera.png" alt="" srcset="">
                        </van-uploader>

                    </template>
                    
                </van-field>
                <span class="tipstext">购买保险，请完善身份证号。</span>
                <!-- </van-cell-group> -->

            </van-form>
        </div>

        <div class="flooter">
            <van-button round block type="primary" native-type="submit" class="submit" @click="onSubmit">
                提交
            </van-button>
        </div>

    </div>
</template>

<script>
import { getIdCard } from '../../apis/informationEntry'
// eslint-disable-next-line no-unused-vars
import { uploadFileCard, addOwnerCode, putOwnerCode } from '../../apis/owner'
import { Toast } from 'vant';
export default {
    data() {
        return {
            user: {
                phone: '',
                name: '',
                sex: '0',
                code: '',
                codeImg: '',
            },
            fileList: [],
            activeIcon:require('../../assets/owner/checked.png'),
            inactiveIcon:require('../../assets/owner/unchecked.png')
        }
    },
    mounted() {
        console.log('数据---------', this.$store.state.ownerInfo)
        let info = this.$store.state.ownerInfo;
        this.user.phone = info.phone;
        this.user.name = info.name;
        this.user.sex = info.sex + '' || '0';
        this.user.code = info.cardId;
    },
    methods: {
        changePhone() {
            this.$router.push({
                path: '/phonelogin',
                query: {
                    name: '切换账号',
                    urldata: 'changePhone',
                }
            })
        },
        beforeRead() {
            // if (file.type !== 'image/jpeg'||file.type !== 'image/png'||file.type !== 'image/jpg'||file.type !== 'image/ai') {
            //     this.$toast('请上传 jpg 格式图片');
            //     return false;
            // }
            return true;
        },
        afterRead(file) {
            // 此时可以自行将文件上传至服务器
            console.log(file);
            Toast.loading({
                message: '上传中...',
                forbidClick: true,
            });
            const formData = new FormData()
            formData.append('file', file.file, new Date().getTime() + file.file.name)
            formData.append('filePath', 'LDZBX/SFZ');
            uploadFileCard(formData).then(res => {
                if (res.status === 0) {
                    this.user.codeImg = res.data.data[0];
                    this.fileList = [{ url: res.data.data[0], isImage: true }];
                    this.identificationCard();
                } else {
                    Toast.fail(res.msg);
                }
            }).catch(err => {
                console.log(err);
                Toast.fail('网络异常请重新上传');
            })
        },
        onSubmit() {
            console.log('提交')
            if (!this.user.name) {
                Toast({
                    position: 'bottom',
                    message: '请输入姓名',//'您已续保，不支持重复续保',
                })
                return
            }
            // if (!this.user.code) {
            //     Toast({
            //         position: 'bottom',
            //         message: '请输入身份证号',//'您已续保，不支持重复续保',
            //     })
            //     return
            // }
            // let req = /^\d{6}((((((19|20)\d{2})(0[13-9]|1[012])(0[1-9]|[12]\d|30))|(((19|20)\d{2})(0[13578]|1[02])31)|((19|20)\d{2})02(0[1-9]|1\d|2[0-8])|((((19|20)([13579][26]|[2468][048]|0[48]))|(2000))0229))\d{3})|((((\d{2})(0[13-9]|1[012])(0[1-9]|[12]\d|30))|((\d{2})(0[13578]|1[02])31)|((\d{2})02(0[1-9]|1\d|2[0-8]))|(([13579][26]|[2468][048]|0[048])0229))\d{2}))(\d|X|x)$/
            // let req = /^[1-9]\\d{5}[1-9]\\d{3}((0\\d)|(1[0-2]))(([0|1|2]\\d)|3[0-1])\\d{3}([0-9Xx])$/;
            let req = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/
            if(this.user.code){
                if (!req.test(this.user.code)) {
                    Toast({
                        position: 'bottom',
                        message: '请输入正确的身份证号',//'您已续保，不支持重复续保',
                    })
                    return
                }
            }
            
            // if(!this.checkSfzh(this.user.code)){
            //     Toast({
            //         position: 'bottom',
            //         message: '请输入正确的身份证号',
            //     })
            //     return
            // }
            
            

            let data = {
                cardFrontUrl: this.user.codeImg,
                cardId: this.user.code || '',
                name: this.user.name,
                phone: this.user.phone,
                sex: this.user.sex,
                openId: localStorage.getItem('openid'),
                codeCreateSource: 1,
                id: this.$store.state.ownerInfo.id || null
            }
            if (this.$store.state.ownerStates == 0) {
                addOwnerCode(data).then((res) => {
                    if (res.status == 0) {
                        this.$store.commit('setOwnerStates',2);
                        this.$store.commit('setOwnerInfo', res.data)
                        this.$router.push({ path: '/authpage' })
                    } else {
                        Toast({
                            position: 'bottom',
                            message: res.msg,
                        })
                    }
                })
            }
            console.log(data)
            if (this.$store.state.ownerStates == 1 || this.$store.state.ownerStates == 2) {
                putOwnerCode(data).then((res) => {
                    if (res.status == 0) {
                        // this.$store.state.ownerInfo = res.data;
                        this.$store.commit('setOwnerInfo', res.data)
                        this.$router.push({ path: '/authpage' })
                    } else {
                        Toast({
                            position: 'bottom',
                            message: res.msg,
                        })
                    }

                })
            }


        },
        /**
        * @description: 识别身份证
        * @param {*} type: 
        */
        identificationCard() {
            let params = {
                ossUrlPath: this.user.codeImg
            };
            getIdCard(params).then(res => {
                console.log('上传身份中', res)
                if (res.data.status == 0) {
                    this.user.code = res.data.data.idNumber
                    this.user.name = res.data.data.name;
                } else {
                    Toast.fail(res.data.msg);
                }
            }).catch(err => {
                console.log('上传身cuo', err)
                Toast.fail('识别失败请手动输入身份证号码');
            })
        },
        checkSfzh(sfzh) {
            let index_array = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
            let sfzh_array = new Array();
            let total = 0;
            let last_number;

            let start = 0;
            let end = 1;
            for (let i = 0; i < sfzh.length - 1; i++) {
                let temp = sfzh.slice(start + i, end + i);
                sfzh_array.push(temp);
            }

            for (let i = 0; i < index_array.length; i++) {
                let temp = sfzh_array[i] * index_array[i];
                total = total + temp;
            }

            switch (total % 11) {
                case 0:
                    last_number = 1;
                    break;
                case 1:
                    last_number = 0;
                    break;
                case 2:
                    last_number = 'X';
                    break;
                case 3:
                    last_number = 9;
                    break;
                case 4:
                    last_number = 8
                    break;
                case 5:
                    last_number = 7;
                    break;
                case 6:
                    last_number = 6;
                    break;
                case 7:
                    last_number = 5;
                    break;
                case 8:
                    last_number = 4;
                    break;
                case 9:
                    last_number = 3
                    break;
                case 10:
                    last_number = 2;
                    break;
            }

            if (sfzh.slice(17, 18) == last_number) {
                return true;
            } else {
                return false;
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.ownerInfo {
    background-color: #F7F7F7;
    height: 100vh;
    .tipstext{
        color: #FF323A;
        font-size: 12px;
        text-align: left;
        display: block;
        position: relative;
        top: -14px;
    }
    .header {
        background: url('../../assets/owner/bg_code@2x.png');
        background-size: 100% 150px;
        width: 100%;
        height: 150px;

        .herder_title {
            font-size: 17px;
            font-weight: 500;
            color: #FFFEFE;
            padding: 30px 15px;
            text-align: right;
            margin-top: 0;
        }
    }

    .card {
        margin: 15px;
        padding: 12px 12px 0 12px;
        border-radius: 8px;
        background-color: #fff;
        margin-top: -40px;

        .tips {
            font-size: 17px;
            font-weight: 600;
            color: #222222;
            text-align: left;
            margin: 0;
            padding-left: 5px;
        }

        .phone {
            background: #EDEDED;
            border-radius: 8px;
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            border: 0;
        }


    }

    .flooter {
        margin: 30px 25px;
    }

    .submit {
        background: #FF323A;
        box-shadow: 2px 4px 8px 1px rgba(255, 72, 72, 0.45);
        border-radius: 46px;
        border: 0;
    }

    .lablestyle {
        white-space: nowrap;
    }
    .lable_t{
        // display: inline-block;
        // vertical-align: middle;
        // text-align: justify;
        // text-align-last: justify;
      
        width: 60px;
        white-space: pre;
    }
   
    .van-cell{
        line-height: 42px;
        align-items: center;
        padding: 10px 5px;
    }
    .van-cell::after{
        right: 5px;
        left: 5px;
    }
    .img-icon {
    height: 18px;
  }
  .endfield:after{
    border-bottom:0
  }
}
</style>